module.exports = __webpack_public_path__ + "img/29.e45ff542.jpg";